import React from 'react';
import { LucideIcon } from 'lucide-react';

interface MobileNavItem {
  id: string;
  label: string;
  icon: LucideIcon;
  badge?: number;
}

interface MobileNavProps {
  items: MobileNavItem[];
  activeId: string;
  onItemClick: (id: string) => void;
}

export const MobileNav: React.FC<MobileNavProps> = ({ items, activeId, onItemClick }) => {
  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 z-40 safe-area-inset-bottom">
      <div className="grid grid-cols-5 h-16">
        {items.map((item) => {
          const Icon = item.icon;
          const isActive = activeId === item.id;

          return (
            <button
              key={item.id}
              onClick={() => onItemClick(item.id)}
              className={`
                flex flex-col items-center justify-center space-y-1 relative
                touch-manipulation transition-colors
                ${isActive ? 'text-slate-900' : 'text-slate-500'}
              `}
            >
              <div className="relative">
                <Icon className={`w-5 h-5 ${isActive ? 'fill-slate-900' : ''}`} />
                {item.badge !== undefined && item.badge > 0 && (
                  <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 text-white text-xs rounded-full flex items-center justify-center">
                    {item.badge > 9 ? '9+' : item.badge}
                  </span>
                )}
              </div>
              <span className={`text-xs font-medium ${isActive ? 'text-slate-900' : 'text-slate-600'}`}>
                {item.label}
              </span>
              {isActive && (
                <span className="absolute top-0 left-1/2 -translate-x-1/2 w-12 h-0.5 bg-slate-900 rounded-b-full" />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
};
